export const locales = ["en", "fr", "es", "pt"];

const dictionary = {
  "en": {
    "lang_label": "Language",
    "app_name": "stash",
    "app_subtitle": "Redis/Valkey GUI for developers",
    "menu": "Menu",
    "open_menu": "Open menu",
    "close_menu": "Close menu",
    "connected": "Connected",
    "disconnected": "Disconnected",
    "pause": "Pause",
    "resume": "Resume",
    "refresh": "Refresh",
    "nav_browse": "Browse",
    "nav_settings": "Settings",
    "nav_runtime": "Runtime",
    "logout": "Logout",
    "store_host": "Store host",
    "login_fallback_subtitle": "Redis GUI/Valkey for developers",
    "api_key": "This instance requires authentication.",
    "login_enter_key": "Enter your API key",
    "login_api_key_required": "API key is required",
    "login_invalid_key": "Invalid API key",
    "login_server_error": "Server error: {status}",
    "login_connection_failed": "Connection failed",
    "login_authenticating": "Authenticating...",
    "login_button": "Continue",
    "dismiss": "Dismiss",
    "loading": "Loading...",
    "auth_required": "Authentication required",
    "session_expired": "Session expired",
    "setup_failed": "Setup failed: {status}",
    "runtime_title": "Runtime",
    "runtime_subtitle": "Live log tail (refreshes every 1s)",
    "runtime_limit": "limit: {limit}",
    "runtime_updated": "updated: {time}",
    "runtime_refresh_now": "Refresh now",
    "runtime_pause_polling": "Pause polling",
    "runtime_resume_polling": "Resume polling",
    "runtime_paused": "Paused",
    "runtime_search": "Search",
    "runtime_search_placeholder": "contains...",
    "runtime_search_hint": "Case-insensitive contains match.",
    "runtime_limit_label": "Limit",
    "runtime_limit_hint": "Client-side cap (max 100).",
    "runtime_error_title": "Runtime tail error",
    "runtime_last_lines": "Last {limit} lines",
    "runtime_shown": "{count} shown",
    "runtime_no_lines": "No lines.",
    "settings_title": "Settings",
    "settings_subtitle": "How this instance is configured",
    "settings_store_connection": "Store connection",
    "settings_engine": "Engine",
    "settings_version": "Version",
    "settings_mode": "Mode",
    "settings_memory": "Memory",
    "settings_connected_clients": "Connected clients",
    "settings_ops_sec": "Ops/sec",
    "settings_lzf_possible": "LZF possible",
    "settings_yes": "Yes",
    "settings_no": "No",
    "settings_auth": "Auth",
    "settings_enabled": "Enabled",
    "settings_disabled": "Disabled",
    "settings_default": "default",
    "settings_store": "Store",
    "settings_store_hosts": "Store hosts",
    "settings_host_count": "{count} host(s)",
    "settings_host": "Host",
    "settings_items": "{count} items",
    "browse_title": "db{db} / browse",
    "browse_subtitle": "Search and browse keys by pattern",
    "browse_last_update": "Last data update",
    "browse_updated": "Updated {time}",
    "browse_add_key": "Add key",
    "browse_refresh_view": "Refresh current view",
    "browse_databases": "Databases",
    "browse_collapse_empty": "Collapse empty databases",
    "browse_expand_empty": "Expand empty databases",
    "browse_empty_range": "db{start}-db{end} empty ({count})",
    "browse_no_databases": "No databases",
    "browse_pattern_placeholder": "Pattern (e.g. cache:*)",
    "browse_search": "Search",
    "browse_mass_delete": "Mass delete by pattern",
    "browse_loaded_range": "{start}-{end} loaded",
    "browse_of_total": "{start}-{end} of {total}",
    "browse_more": "more",
    "browse_previous_page": "Previous page",
    "browse_next_page": "Next page",
    "browse_prev": "Prev",
    "browse_next": "Next",
    "browse_sort": "Sort",
    "browse_sort_name_asc": "Name A-Z",
    "browse_sort_name_desc": "Name Z-A",
    "browse_sort_type_asc": "Type A-Z",
    "browse_sort_type_desc": "Type Z-A",
    "browse_name_up": "Name ↑",
    "browse_type_up": "Type ↑",
    "browse_value_type": "Value type",
    "browse_ttl": "TTL",
    "browse_no_expiry": "No expiry",
    "browse_no_keys": "No keys found",
    "browse_showing_total": "Showing {start}-{end} of {total}",
    "browse_showing_loaded": "Showing {start}-{end} loaded",
    "browse_all_for_pattern": "all for this pattern",
    "browse_add_key_title": "Add key",
    "browse_key_name_hint": "Key name (use colons for folders, e.g. session:user:123)",
    "browse_key_name_placeholder": "e.g. mykey or folder:sub:key",
    "browse_type_string": "Type: String",
    "browse_value_placeholder": "Value",
    "browse_save_key": "Save key",
    "browse_saving": "Saving...",
    "browse_cancel": "Cancel",
    "browse_delete_key_title": "Delete key?",
    "browse_delete_keys_title": "Delete keys by pattern",
    "browse_delete_keys_hint": "This will permanently delete all keys matching the pattern.",
    "browse_delete_pattern_placeholder": "e.g. cache:* or *",
    "browse_deleting": "Deleting...",
    "browse_delete": "Delete",
    "browse_delete_all_matching": "Delete all matching",
    "browse_keys_deleted": "Keys deleted",
    "browse_deleted_count": "Deleted {count} key(s).",
    "browse_close": "Close",
    "browse_key_name_required": "Key name is required",
    "detail_refresh": "Refresh",
    "detail_delete": "Delete",
    "detail_close": "Close",
    "detail_expires_in": "Expires in:",
    "detail_size": "Size:",
    "detail_bytes": "bytes",
    "detail_items": "items",
    "detail_format": "Format:",
    "detail_value_preview": "Value (read-only preview)",
    "detail_value": "Value",
    "detail_ttl_label": "TTL (seconds, 0 = no expiry)",
    "detail_save": "Save",
    "detail_loading": "Loading...",
    "detail_json": "JSON",
    "detail_php": "PHP serialized",
    "detail_plain": "Plain",
    "error_key_missing": "Key not found (may have been removed by another client).",
    "error_key_exists": "A key with this name already exists.",
    "error_key_may_be_pulled": "Key may have been pulled or removed by another client.",
    "error_store_unavailable": "Redis is unavailable. Try again later.",
    "error_store_error": "Storage error. Try again.",
    "error_request_failed": "Request failed ({status}).",
    "login_acdev_headline": "ship faster with baseblox",
    "login_acdev_description": "baseblox is a suite of microservices ready to drop into your infrastructure which reduces the time to build complex applications and the costs of platforms like AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licensing & support",
    "login_acdev_contact": "support@acdevservices.com"
  },
  "fr": {
    "lang_label": "Langue",
    "app_name": "stash",
    "app_subtitle": "Interface Redis",
    "menu": "Menu",
    "open_menu": "Ouvrir le menu",
    "close_menu": "Fermer le menu",
    "connected": "Connecté",
    "disconnected": "Déconnecté",
    "pause": "Pause",
    "resume": "Reprendre",
    "refresh": "Rafraîchir",
    "nav_browse": "Parcourir",
    "nav_settings": "Paramètres",
    "nav_runtime": "Runtime",
    "logout": "Déconnexion",
    "store_host": "Hôte du store",
    "login_fallback_subtitle": "Interface Redis pour développeurs",
    "api_key": "Clé API",
    "login_enter_key": "Entrez votre clé API",
    "login_api_key_required": "La clé API est obligatoire",
    "login_invalid_key": "Clé API invalide",
    "login_server_error": "Erreur serveur : {status}",
    "login_connection_failed": "Échec de connexion",
    "login_authenticating": "Authentification...",
    "login_button": "Connexion",
    "dismiss": "Fermer",
    "loading": "Chargement...",
    "auth_required": "Authentification requise",
    "session_expired": "Session expirée",
    "setup_failed": "Échec du setup : {status}",
    "runtime_title": "Runtime",
    "runtime_subtitle": "Flux de logs en direct (rafraîchi toutes les 1 s)",
    "runtime_limit": "limite : {limit}",
    "runtime_updated": "mis à jour : {time}",
    "runtime_refresh_now": "Rafraîchir maintenant",
    "runtime_pause_polling": "Mettre en pause",
    "runtime_resume_polling": "Reprendre",
    "runtime_paused": "En pause",
    "runtime_search": "Recherche",
    "runtime_search_placeholder": "contient...",
    "runtime_search_hint": "Correspondance insensible à la casse.",
    "runtime_limit_label": "Limite",
    "runtime_limit_hint": "Plafond côté client (max 100).",
    "runtime_error_title": "Erreur du flux runtime",
    "runtime_last_lines": "Dernières {limit} lignes",
    "runtime_shown": "{count} affichées",
    "runtime_no_lines": "Aucune ligne.",
    "settings_title": "Paramètres",
    "settings_subtitle": "Configuration de cette instance",
    "settings_store_connection": "Connexion au store",
    "settings_engine": "Moteur",
    "settings_version": "Version",
    "settings_mode": "Mode",
    "settings_memory": "Mémoire",
    "settings_connected_clients": "Clients connectés",
    "settings_ops_sec": "Ops/sec",
    "settings_lzf_possible": "LZF possible",
    "settings_yes": "Oui",
    "settings_no": "Non",
    "settings_auth": "Auth",
    "settings_enabled": "Activé",
    "settings_disabled": "Désactivé",
    "settings_default": "défaut",
    "settings_store": "Store",
    "settings_store_hosts": "Hôtes du store",
    "settings_host_count": "{count} hôte(s)",
    "settings_host": "Hôte",
    "settings_items": "{count} éléments",
    "browse_title": "db{db} / parcourir",
    "browse_subtitle": "Rechercher et parcourir les clés par motif",
    "browse_last_update": "Dernière mise à jour",
    "browse_updated": "Mis à jour {time}",
    "browse_add_key": "Ajouter une clé",
    "browse_refresh_view": "Rafraîchir la vue",
    "browse_databases": "Bases",
    "browse_collapse_empty": "Réduire les bases vides",
    "browse_expand_empty": "Développer les bases vides",
    "browse_empty_range": "db{start}-db{end} vide ({count})",
    "browse_no_databases": "Aucune base",
    "browse_pattern_placeholder": "Motif (ex. cache:*)",
    "browse_search": "Rechercher",
    "browse_mass_delete": "Suppression par motif",
    "browse_loaded_range": "{start}-{end} chargés",
    "browse_of_total": "{start}-{end} sur {total}",
    "browse_more": "plus",
    "browse_previous_page": "Page précédente",
    "browse_next_page": "Page suivante",
    "browse_prev": "Préc.",
    "browse_next": "Suiv.",
    "browse_sort": "Tri",
    "browse_sort_name_asc": "Nom A-Z",
    "browse_sort_name_desc": "Nom Z-A",
    "browse_sort_type_asc": "Type A-Z",
    "browse_sort_type_desc": "Type Z-A",
    "browse_name_up": "Nom ↑",
    "browse_type_up": "Type ↑",
    "browse_value_type": "Type de valeur",
    "browse_ttl": "TTL",
    "browse_no_expiry": "Pas d'expiration",
    "browse_no_keys": "Aucune clé trouvée",
    "browse_showing_total": "Affichage de {start}-{end} sur {total}",
    "browse_showing_loaded": "Affichage de {start}-{end} chargés",
    "browse_all_for_pattern": "tout pour ce motif",
    "browse_add_key_title": "Ajouter une clé",
    "browse_key_name_hint": "Nom de clé (utilisez des deux-points pour les dossiers, ex. session:user:123)",
    "browse_key_name_placeholder": "ex. ma-cle ou dossier:sous:cle",
    "browse_type_string": "Type : String",
    "browse_value_placeholder": "Valeur",
    "browse_save_key": "Enregistrer la clé",
    "browse_saving": "Enregistrement...",
    "browse_cancel": "Annuler",
    "browse_delete_key_title": "Supprimer la clé ?",
    "browse_delete_keys_title": "Supprimer les clés par motif",
    "browse_delete_keys_hint": "Cela supprimera définitivement toutes les clés correspondant au motif.",
    "browse_delete_pattern_placeholder": "ex. cache:* ou *",
    "browse_deleting": "Suppression...",
    "browse_delete": "Supprimer",
    "browse_delete_all_matching": "Supprimer toutes les correspondances",
    "browse_keys_deleted": "Clés supprimées",
    "browse_deleted_count": "{count} clé(s) supprimée(s).",
    "browse_close": "Fermer",
    "browse_key_name_required": "Le nom de clé est obligatoire",
    "detail_refresh": "Rafraîchir",
    "detail_delete": "Supprimer",
    "detail_close": "Fermer",
    "detail_expires_in": "Expire dans :",
    "detail_size": "Taille :",
    "detail_bytes": "octets",
    "detail_items": "éléments",
    "detail_format": "Format :",
    "detail_value_preview": "Valeur (aperçu en lecture seule)",
    "detail_value": "Valeur",
    "detail_ttl_label": "TTL (secondes, 0 = pas d'expiration)",
    "detail_save": "Enregistrer",
    "detail_loading": "Chargement...",
    "detail_json": "JSON",
    "detail_php": "PHP sérialisé",
    "detail_plain": "Brut",
    "error_key_missing": "Clé introuvable (elle a peut-être été supprimée par un autre client).",
    "error_key_exists": "Une clé avec ce nom existe déjà.",
    "error_key_may_be_pulled": "La clé a peut-être été supprimée par un autre client.",
    "error_store_unavailable": "Redis est indisponible. Réessayez plus tard.",
    "error_store_error": "Erreur de stockage. Réessayez.",
    "error_request_failed": "Échec de la requête ({status}).",
    "login_acdev_headline": "allez plus vite avec baseblox",
    "login_acdev_description": "baseblox est une suite de microservices prets a integrer dans votre infrastructure pour reduire le temps de developpement des applications complexes et les couts de plateformes comme AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licences & support",
    "login_acdev_contact": "support@acdevservices.com"
  },
  "es": {
    "lang_label": "Idioma",
    "app_name": "stash",
    "app_subtitle": "Interfaz Redis",
    "menu": "Menú",
    "open_menu": "Abrir menú",
    "close_menu": "Cerrar menú",
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "pause": "Pausar",
    "resume": "Reanudar",
    "refresh": "Actualizar",
    "nav_browse": "Explorar",
    "nav_settings": "Configuración",
    "nav_runtime": "Runtime",
    "logout": "Cerrar sesión",
    "store_host": "Host de almacenamiento",
    "login_fallback_subtitle": "Interfaz Redis para desarrolladores",
    "api_key": "Clave API",
    "login_enter_key": "Ingresa tu clave API",
    "login_api_key_required": "La clave API es obligatoria",
    "login_invalid_key": "Clave API inválida",
    "login_server_error": "Error del servidor: {status}",
    "login_connection_failed": "Error de conexión",
    "login_authenticating": "Autenticando...",
    "login_button": "Ingresar",
    "dismiss": "Descartar",
    "loading": "Cargando...",
    "auth_required": "Autenticación obligatoria",
    "session_expired": "Sesión expirada",
    "setup_failed": "Fallo de setup: {status}",
    "runtime_title": "Runtime",
    "runtime_subtitle": "Cola de logs en vivo (se actualiza cada 1 s)",
    "runtime_limit": "límite: {limit}",
    "runtime_updated": "actualizado: {time}",
    "runtime_refresh_now": "Actualizar ahora",
    "runtime_pause_polling": "Pausar sondeo",
    "runtime_resume_polling": "Reanudar sondeo",
    "runtime_paused": "Pausado",
    "runtime_search": "Buscar",
    "runtime_search_placeholder": "contiene...",
    "runtime_search_hint": "Coincidencia sin distinguir mayúsculas.",
    "runtime_limit_label": "Límite",
    "runtime_limit_hint": "Tope del cliente (máx. 100).",
    "runtime_error_title": "Error de cola runtime",
    "runtime_last_lines": "Últimas {limit} líneas",
    "runtime_shown": "{count} mostradas",
    "runtime_no_lines": "Sin líneas.",
    "settings_title": "Configuración",
    "settings_subtitle": "Cómo está configurada esta instancia",
    "settings_store_connection": "Conexión al store",
    "settings_engine": "Motor",
    "settings_version": "Versión",
    "settings_mode": "Modo",
    "settings_memory": "Memoria",
    "settings_connected_clients": "Clientes conectados",
    "settings_ops_sec": "Ops/sec",
    "settings_lzf_possible": "LZF posible",
    "settings_yes": "Sí",
    "settings_no": "No",
    "settings_auth": "Auth",
    "settings_enabled": "Activado",
    "settings_disabled": "Desactivado",
    "settings_default": "predeterminado",
    "settings_store": "Store",
    "settings_store_hosts": "Hosts del store",
    "settings_host_count": "{count} host(s)",
    "settings_host": "Host",
    "settings_items": "{count} elementos",
    "browse_title": "db{db} / explorar",
    "browse_subtitle": "Busca y explora claves por patrón",
    "browse_last_update": "Última actualización",
    "browse_updated": "Actualizado {time}",
    "browse_add_key": "Agregar clave",
    "browse_refresh_view": "Actualizar vista",
    "browse_databases": "Bases de datos",
    "browse_collapse_empty": "Contraer bases vacías",
    "browse_expand_empty": "Expandir bases vacías",
    "browse_empty_range": "db{start}-db{end} vacía ({count})",
    "browse_no_databases": "Sin bases de datos",
    "browse_pattern_placeholder": "Patrón (ej. cache:*)",
    "browse_search": "Buscar",
    "browse_mass_delete": "Borrado masivo por patrón",
    "browse_loaded_range": "{start}-{end} cargados",
    "browse_of_total": "{start}-{end} de {total}",
    "browse_more": "más",
    "browse_previous_page": "Página anterior",
    "browse_next_page": "Página siguiente",
    "browse_prev": "Ant.",
    "browse_next": "Sig.",
    "browse_sort": "Ordenar",
    "browse_sort_name_asc": "Nombre A-Z",
    "browse_sort_name_desc": "Nombre Z-A",
    "browse_sort_type_asc": "Tipo A-Z",
    "browse_sort_type_desc": "Tipo Z-A",
    "browse_name_up": "Nombre ↑",
    "browse_type_up": "Tipo ↑",
    "browse_value_type": "Tipo de valor",
    "browse_ttl": "TTL",
    "browse_no_expiry": "Sin expiración",
    "browse_no_keys": "No se encontraron claves",
    "browse_showing_total": "Mostrando {start}-{end} de {total}",
    "browse_showing_loaded": "Mostrando {start}-{end} cargados",
    "browse_all_for_pattern": "todo para este patrón",
    "browse_add_key_title": "Agregar clave",
    "browse_key_name_hint": "Nombre de la clave (usa dos puntos para carpetas, ej. session:user:123)",
    "browse_key_name_placeholder": "ej. miclave o carpeta:sub:clave",
    "browse_type_string": "Tipo: String",
    "browse_value_placeholder": "Valor",
    "browse_save_key": "Guardar clave",
    "browse_saving": "Guardando...",
    "browse_cancel": "Cancelar",
    "browse_delete_key_title": "¿Eliminar clave?",
    "browse_delete_keys_title": "Eliminar claves por patrón",
    "browse_delete_keys_hint": "Esto eliminará permanentemente todas las claves que coincidan con el patrón.",
    "browse_delete_pattern_placeholder": "ej. cache:* o *",
    "browse_deleting": "Eliminando...",
    "browse_delete": "Eliminar",
    "browse_delete_all_matching": "Eliminar todas las coincidencias",
    "browse_keys_deleted": "Claves eliminadas",
    "browse_deleted_count": "Se eliminaron {count} clave(s).",
    "browse_close": "Cerrar",
    "browse_key_name_required": "El nombre de la clave es obligatorio",
    "detail_refresh": "Actualizar",
    "detail_delete": "Eliminar",
    "detail_close": "Cerrar",
    "detail_expires_in": "Expira en:",
    "detail_size": "Tamaño:",
    "detail_bytes": "bytes",
    "detail_items": "elementos",
    "detail_format": "Formato:",
    "detail_value_preview": "Valor (vista previa de solo lectura)",
    "detail_value": "Valor",
    "detail_ttl_label": "TTL (segundos, 0 = sin expiración)",
    "detail_save": "Guardar",
    "detail_loading": "Cargando...",
    "detail_json": "JSON",
    "detail_php": "PHP serializado",
    "detail_plain": "Plano",
    "error_key_missing": "Clave no encontrada (puede haber sido eliminada por otro cliente).",
    "error_key_exists": "Ya existe una clave con este nombre.",
    "error_key_may_be_pulled": "La clave pudo haber sido eliminada por otro cliente.",
    "error_store_unavailable": "Redis no está disponible. Inténtalo más tarde.",
    "error_store_error": "Error de almacenamiento. Inténtalo de nuevo.",
    "error_request_failed": "La solicitud falló ({status}).",
    "login_acdev_headline": "lanza mas rapido con baseblox",
    "login_acdev_description": "baseblox es una suite de microservicios lista para integrarse en tu infraestructura y reducir tanto el tiempo necesario para crear aplicaciones complejas como los costes de plataformas como AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licencias y soporte",
    "login_acdev_contact": "support@acdevservices.com"
  },
  "pt": {
    "lang_label": "Idioma",
    "app_name": "stash",
    "app_subtitle": "Interface Redis",
    "menu": "Menu",
    "open_menu": "Abrir menu",
    "close_menu": "Fechar menu",
    "connected": "Conectado",
    "disconnected": "Desconectado",
    "pause": "Pausar",
    "resume": "Retomar",
    "refresh": "Atualizar",
    "nav_browse": "Navegar",
    "nav_settings": "Configurações",
    "nav_runtime": "Runtime",
    "logout": "Sair",
    "store_host": "Host de armazenamento",
    "login_fallback_subtitle": "Interface Redis para desenvolvedores",
    "api_key": "Chave API",
    "login_enter_key": "Digite sua chave de API",
    "login_api_key_required": "A chave de API é obrigatória",
    "login_invalid_key": "Chave de API inválida",
    "login_server_error": "Erro do servidor: {status}",
    "login_connection_failed": "Falha de conexão",
    "login_authenticating": "Autenticando...",
    "login_button": "Entrar",
    "dismiss": "Dispensar",
    "loading": "Carregando...",
    "auth_required": "Autenticacao obrigatoria",
    "session_expired": "Sessao expirada",
    "setup_failed": "Falha no setup: {status}",
    "runtime_title": "Runtime",
    "runtime_subtitle": "Cauda de logs ao vivo (atualiza a cada 1 s)",
    "runtime_limit": "limite: {limit}",
    "runtime_updated": "atualizado: {time}",
    "runtime_refresh_now": "Atualizar agora",
    "runtime_pause_polling": "Pausar polling",
    "runtime_resume_polling": "Retomar polling",
    "runtime_paused": "Pausado",
    "runtime_search": "Buscar",
    "runtime_search_placeholder": "contem...",
    "runtime_search_hint": "Correspondencia sem diferenciar maiusculas.",
    "runtime_limit_label": "Limite",
    "runtime_limit_hint": "Limite do cliente (max 100).",
    "runtime_error_title": "Erro da cauda runtime",
    "runtime_last_lines": "Ultimas {limit} linhas",
    "runtime_shown": "{count} exibidas",
    "runtime_no_lines": "Sem linhas.",
    "settings_title": "Configuracoes",
    "settings_subtitle": "Como esta instancia esta configurada",
    "settings_store_connection": "Conexao ao store",
    "settings_engine": "Motor",
    "settings_version": "Versao",
    "settings_mode": "Modo",
    "settings_memory": "Memoria",
    "settings_connected_clients": "Clientes conectados",
    "settings_ops_sec": "Ops/sec",
    "settings_lzf_possible": "LZF possivel",
    "settings_yes": "Sim",
    "settings_no": "Nao",
    "settings_auth": "Auth",
    "settings_enabled": "Ativado",
    "settings_disabled": "Desativado",
    "settings_default": "padrao",
    "settings_store": "Store",
    "settings_store_hosts": "Hosts do store",
    "settings_host_count": "{count} host(s)",
    "settings_host": "Host",
    "settings_items": "{count} itens",
    "browse_title": "db{db} / navegar",
    "browse_subtitle": "Pesquise e navegue por chaves com padrao",
    "browse_last_update": "Ultima atualizacao",
    "browse_updated": "Atualizado {time}",
    "browse_add_key": "Adicionar chave",
    "browse_refresh_view": "Atualizar visualizacao",
    "browse_databases": "Bancos",
    "browse_collapse_empty": "Recolher bancos vazios",
    "browse_expand_empty": "Expandir bancos vazios",
    "browse_empty_range": "db{start}-db{end} vazio ({count})",
    "browse_no_databases": "Sem bancos",
    "browse_pattern_placeholder": "Padrao (ex. cache:*)",
    "browse_search": "Buscar",
    "browse_mass_delete": "Exclusao em massa por padrao",
    "browse_loaded_range": "{start}-{end} carregados",
    "browse_of_total": "{start}-{end} de {total}",
    "browse_more": "mais",
    "browse_previous_page": "Pagina anterior",
    "browse_next_page": "Proxima pagina",
    "browse_prev": "Ant.",
    "browse_next": "Prox.",
    "browse_sort": "Ordenar",
    "browse_sort_name_asc": "Nome A-Z",
    "browse_sort_name_desc": "Nome Z-A",
    "browse_sort_type_asc": "Tipo A-Z",
    "browse_sort_type_desc": "Tipo Z-A",
    "browse_name_up": "Nome ↑",
    "browse_type_up": "Tipo ↑",
    "browse_value_type": "Tipo de valor",
    "browse_ttl": "TTL",
    "browse_no_expiry": "Sem expiracao",
    "browse_no_keys": "Nenhuma chave encontrada",
    "browse_showing_total": "Mostrando {start}-{end} de {total}",
    "browse_showing_loaded": "Mostrando {start}-{end} carregados",
    "browse_all_for_pattern": "tudo para este padrao",
    "browse_add_key_title": "Adicionar chave",
    "browse_key_name_hint": "Nome da chave (use dois-pontos para pastas, ex. session:user:123)",
    "browse_key_name_placeholder": "ex. minhachave ou pasta:sub:chave",
    "browse_type_string": "Tipo: String",
    "browse_value_placeholder": "Valor",
    "browse_save_key": "Salvar chave",
    "browse_saving": "Salvando...",
    "browse_cancel": "Cancelar",
    "browse_delete_key_title": "Excluir chave?",
    "browse_delete_keys_title": "Excluir chaves por padrao",
    "browse_delete_keys_hint": "Isso excluira permanentemente todas as chaves que correspondem ao padrao.",
    "browse_delete_pattern_placeholder": "ex. cache:* ou *",
    "browse_deleting": "Excluindo...",
    "browse_delete": "Excluir",
    "browse_delete_all_matching": "Excluir todas as correspondencias",
    "browse_keys_deleted": "Chaves excluidas",
    "browse_deleted_count": "{count} chave(s) excluida(s).",
    "browse_close": "Fechar",
    "browse_key_name_required": "O nome da chave e obrigatorio",
    "detail_refresh": "Atualizar",
    "detail_delete": "Excluir",
    "detail_close": "Fechar",
    "detail_expires_in": "Expira em:",
    "detail_size": "Tamanho:",
    "detail_bytes": "bytes",
    "detail_items": "itens",
    "detail_format": "Formato:",
    "detail_value_preview": "Valor (visualizacao somente leitura)",
    "detail_value": "Valor",
    "detail_ttl_label": "TTL (segundos, 0 = sem expiracao)",
    "detail_save": "Salvar",
    "detail_loading": "Carregando...",
    "detail_json": "JSON",
    "detail_php": "PHP serializado",
    "detail_plain": "Plano",
    "error_key_missing": "Chave nao encontrada (pode ter sido removida por outro cliente).",
    "error_key_exists": "Ja existe uma chave com esse nome.",
    "error_key_may_be_pulled": "A chave pode ter sido removida por outro cliente.",
    "error_store_unavailable": "Redis esta indisponivel. Tente novamente mais tarde.",
    "error_store_error": "Erro de armazenamento. Tente novamente.",
    "error_request_failed": "Falha na requisicao ({status}).",
    "login_acdev_headline": "entregue mais rapido com baseblox",
    "login_acdev_description": "baseblox e uma suite de microsservicos pronta para entrar na sua infraestrutura e reduzir tanto o tempo de criacao de aplicacoes complexas quanto os custos de plataformas como a AWS.",
    "login_acdev_link": "acdevservices.com",
    "login_acdev_licensing": "licenciamento e suporte",
    "login_acdev_contact": "support@acdevservices.com"
  }
};

export function t(locale, key, params = {}) {
  let value = dictionary[locale]?.[key] ?? dictionary.en[key] ?? key;
  Object.entries(params).forEach(([k, v]) => {
    value = value.replaceAll(`{${k}}`, String(v));
  });
  return value;
}
